import Tabsbar from "../components/tabsbar";

function Projects() {
  return (
    <div>
      <Tabsbar></Tabsbar>
    </div>
  );
}
export default Projects;
